"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluggableHeatmap = void 0;
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var sdk_ui_1 = require("@gooddata/sdk-ui");
var react_1 = tslib_1.__importDefault(require("react"));
var react_dom_1 = require("react-dom");
var bucket_1 = require("../../../constants/bucket");
var supportedProperties_1 = require("../../../constants/supportedProperties");
var uiConfig_1 = require("../../../constants/uiConfig");
var bucketConfig_1 = require("../../../utils/bucketConfig");
var bucketHelper_1 = require("../../../utils/bucketHelper");
var propertiesHelper_1 = require("../../../utils/propertiesHelper");
var sort_1 = require("../../../utils/sort");
var heatmapUiConfigHelper_1 = require("../../../utils/uiConfigHelpers/heatmapUiConfigHelper");
var HeatMapConfigurationPanel_1 = tslib_1.__importDefault(require("../../configurationPanels/HeatMapConfigurationPanel"));
var PluggableBaseChart_1 = require("../baseChart/PluggableBaseChart");
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var includes_1 = tslib_1.__importDefault(require("lodash/includes"));
var set_1 = tslib_1.__importDefault(require("lodash/set"));
var tail_1 = tslib_1.__importDefault(require("lodash/tail"));
var ImplicitDrillDownHelper_1 = require("../../../utils/ImplicitDrillDownHelper");
var drillDownUtil_1 = require("../drillDownUtil");
var PluggableHeatmap = /** @class */ (function (_super) {
    tslib_1.__extends(PluggableHeatmap, _super);
    function PluggableHeatmap(props) {
        var _this = _super.call(this, props) || this;
        _this.type = sdk_ui_1.VisualizationTypes.HEATMAP;
        _this.supportedPropertiesList = supportedProperties_1.HEATMAP_SUPPORTED_PROPERTIES;
        _this.initializeProperties(props.visualizationProperties);
        return _this;
    }
    PluggableHeatmap.prototype.getExtendedReferencePoint = function (referencePoint) {
        var clonedReferencePoint = cloneDeep_1.default(referencePoint);
        var newReferencePoint = tslib_1.__assign(tslib_1.__assign({}, clonedReferencePoint), { uiConfig: cloneDeep_1.default(uiConfig_1.DEFAULT_HEATMAP_UICONFIG) });
        newReferencePoint = bucketHelper_1.removeAllArithmeticMeasuresFromDerived(newReferencePoint);
        newReferencePoint = bucketHelper_1.removeAllDerivedMeasures(newReferencePoint);
        var buckets = bucketHelper_1.limitNumberOfMeasuresInBuckets(clonedReferencePoint.buckets, 1);
        var allAttributes = bucketHelper_1.getAllAttributeItemsWithPreference(buckets, [
            sdk_ui_1.BucketNames.VIEW,
            sdk_ui_1.BucketNames.TREND,
            sdk_ui_1.BucketNames.LOCATION,
            sdk_ui_1.BucketNames.STACK,
            sdk_ui_1.BucketNames.SEGMENT,
        ]);
        var stackItems = bucketHelper_1.getPreferredBucketItems(buckets, [sdk_ui_1.BucketNames.STACK, sdk_ui_1.BucketNames.SEGMENT], [bucket_1.ATTRIBUTE, bucket_1.DATE]);
        var measures = bucketHelper_1.getMeasureItems(buckets);
        var rowItems = allAttributes.filter(function (attribute) {
            return !includes_1.default(stackItems, attribute);
        });
        var columnItems = allAttributes.length > 1 ? tail_1.default(allAttributes) : stackItems;
        set_1.default(newReferencePoint, bucket_1.BUCKETS, [
            {
                localIdentifier: sdk_ui_1.BucketNames.MEASURES,
                items: measures,
            },
            {
                localIdentifier: sdk_ui_1.BucketNames.VIEW,
                items: rowItems.slice(0, 1),
            },
            {
                localIdentifier: sdk_ui_1.BucketNames.STACK,
                items: columnItems.slice(0, 1),
            },
        ]);
        newReferencePoint = heatmapUiConfigHelper_1.setHeatmapUiConfig(newReferencePoint, this.intl, this.type);
        newReferencePoint = bucketConfig_1.configurePercent(newReferencePoint, true);
        newReferencePoint = bucketConfig_1.configureOverTimeComparison(newReferencePoint, !!this.featureFlags["enableWeekFilters"]);
        newReferencePoint = propertiesHelper_1.getReferencePointWithSupportedProperties(newReferencePoint, this.supportedPropertiesList);
        newReferencePoint = sort_1.removeSort(newReferencePoint);
        return Promise.resolve(bucketHelper_1.sanitizeFilters(newReferencePoint));
    };
    PluggableHeatmap.prototype.addFilters = function (source, drillConfig, event) {
        var clicked = ImplicitDrillDownHelper_1.drillDownFromAttributeLocalId(drillConfig);
        var cutIntersection = (event.drillContext.intersection || []).filter(function (i) {
            return sdk_ui_1.isDrillIntersectionAttributeItem(i.header) &&
                i.header.attributeHeader.localIdentifier === clicked;
        });
        return drillDownUtil_1.addIntersectionFiltersToInsight(source, cutIntersection);
    };
    PluggableHeatmap.prototype.getInsightWithDrillDownApplied = function (source, drillDownContext) {
        var withFilters = this.addFilters(source, drillDownContext.drillDefinition, drillDownContext.event);
        return drillDownUtil_1.modifyBucketsAttributesForDrillDown(withFilters, drillDownContext.drillDefinition);
    };
    PluggableHeatmap.prototype.renderConfigurationPanel = function (insight) {
        if (document.querySelector(this.configPanelElement)) {
            react_dom_1.render(react_1.default.createElement(HeatMapConfigurationPanel_1.default, { locale: this.locale, references: this.references, properties: this.visualizationProperties, propertiesMeta: this.propertiesMeta, insight: insight, colors: this.colors, pushData: this.handlePushData, type: this.type, isError: this.getIsError(), isLoading: this.isLoading, featureFlags: this.featureFlags }), document.querySelector(this.configPanelElement));
        }
        return null;
    };
    return PluggableHeatmap;
}(PluggableBaseChart_1.PluggableBaseChart));
exports.PluggableHeatmap = PluggableHeatmap;
//# sourceMappingURL=PluggableHeatmap.js.map